module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/main-view_afb00418f06264b2d3f6940a2ed93da4.png";